import { useAtom } from '@reatom/npm-react'
import { Controller, useFormContext } from 'react-hook-form'
import styled from 'styled-components'

import { Network, selectedNetworkAtom } from '@root/entities/network'
import { AntiMevShield } from '@root/features/trade/trade-settings/ui/desktop'
import { useTranslation } from '@root/shared/localization'

import { TradeSettingsLabel } from './common/trade-settings-label'
import { TradeSettingsSwitch } from './common/trade-settings-switch'

import type { TradeSettingsValues } from '../../common'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  antiMevName: 'antiMev' | 'jitoEnabled'
} & ClassNameProps

export const TradeSettingsFormMev: React.FC<Props> = ({
  className,
  antiMevName,
}) => {
  const { control, watch } = useFormContext<TradeSettingsValues>()
  const { t } = useTranslation()
  const [network] = useAtom(selectedNetworkAtom)
  const antiMevEnabled = watch(antiMevName)

  const shouldShowAntiMev = isMevAvailable(network)

  if (!shouldShowAntiMev) {
    return undefined
  }

  return (
    <Root className={className}>
      <TradeSettingsLabel toolTipMessage={t('trade_settings.anti_mev_tooltip')}>
        <AntiMevShield size={16} active={antiMevEnabled} />
        {t('trade_settings.anti_mev')}
      </TradeSettingsLabel>
      <Controller
        control={control}
        name={antiMevName}
        render={({ field }) => (
          <TradeSettingsSwitch
            value={field.value}
            onChange={(value) => {
              field.onChange(value)
            }}
          />
        )}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
`

export const isMevAvailable = (network: Network.Network) => {
  return network === Network.Solana
}
